import {
  PROJECT_KINDS,
  PROJECT_STATUSES,
  type ProjectKind,
  type ProjectStatus,
} from '@glory/projects/domain';

const flag = (value: unknown): true | undefined => (value === true || value === 'true' ? true : undefined);

/** «Проекты» живут в адресе: вид раздела и фильтры — ссылкой можно поделиться. */
export interface ProjectsSearch {
  /** Без значения — список. */
  readonly view?: 'gantt' | 'load' | undefined;
  /** Без значения — «Мои»: где вы руководитель или участник. */
  readonly scope?: 'all' | undefined;
  readonly kind?: ProjectKind | undefined;
  readonly status?: ProjectStatus | undefined;
  /** Показать архив вместо действующих. */
  readonly archived?: true | undefined;
  /** Открыть «Новый проект» — команда ⌘K. */
  readonly create?: true | undefined;
}

export function parseProjectsSearch(search: Record<string, unknown>): ProjectsSearch {
  return {
    view: search.view === 'gantt' || search.view === 'load' ? search.view : undefined,
    scope: search.scope === 'all' ? 'all' : undefined,
    kind: PROJECT_KINDS.find((kind) => kind === search.kind),
    status: PROJECT_STATUSES.find((status) => status === search.status),
    archived: flag(search.archived),
    create: flag(search.create),
  };
}

const PROJECT_TABS = [
  'kanban',
  'gantt',
  'hours',
  'time',
  'tz',
  'documents',
  'money',
  'vault',
  'client',
  'forClient',
] as const;

/**
 * Проект: вкладка «Сроки», «Часы», «Время», «ТЗ», «Документы», «Деньги» или «Клиент» (без значения — «Задачи»; старое «kanban» — задачи доской),
 * вид задач (список или доска) и группировка списка.
 */
export interface ProjectSearch {
  readonly tab?: (typeof PROJECT_TABS)[number] | undefined;
  readonly view?: 'board' | undefined;
  readonly group?: 'assignee' | undefined;
}

export function parseProjectSearch(search: Record<string, unknown>): ProjectSearch {
  return {
    tab: PROJECT_TABS.find((tab) => tab === search.tab),
    view: search.view === 'board' ? 'board' : undefined,
    group: search.group === 'assignee' ? 'assignee' : undefined,
  };
}
